import {mapRunningTimes} from '@domain/shared'
import {Config} from '@domain/shifthandover'
import {
  type EquipmentRunningTimes,
  type EquipmentRunningTimesDto,
  type TimeZone
} from '@hconnect/common/types'

export const mapEquipmentRunningTimes = (
  equipmentRunningTime: EquipmentRunningTimesDto[],
  timezone: TimeZone
): EquipmentRunningTimes[] =>
  equipmentRunningTime.map((data) => ({
    ...data,
    runningTimes: mapRunningTimes(data.runningTimes, timezone)
  }))

export const getEquipmentStoppageCodesByStoppageType = (plantConfig: Config | undefined) => {
  return {
    kiln: plantConfig?.kilnStoppageCodes ?? [],
    cementMill: plantConfig?.finishMillStoppageCodes ?? [],
    rawMill: plantConfig?.rawMillStoppageCodes ?? [],
    alternativeFuelInstallation: plantConfig?.alternativeFuelInstallationStoppageCodes ?? []
  }
}
